export enum CompaniesItemsActions {
  ActivateCompany = 'companiesGridActivateCompanyAction',
  SuspendCompany = 'companiesGridSuspendCompanyAction',
  ImportCompanyFromConnectWise = 'companiesGridImportCompanyFromConnectWiseAction',
  RevokeMSPInProductTrialsForMdr = 'companiesGridRevokeMSPInProductTrialsForMdr',
  AllowMSPInProductTrialsForMdr = 'companiesGridAllowMSPInProductTrialsForMdr',
  RevokeMSPInProductTrialsForEdr = 'companiesGridRevokeMSPInProductTrialsForEdr',
  AllowMSPInProductTrialsForEdr = 'companiesGridAllowMSPInProductTrialsForEdr',
  RevokeMSPInProductTrialsVisibilityForMdr = 'companiesGridRevokeMSPInProductTrialsVisibilityForMdr',
  AllowMSPInProductTrialsVisibilityForMdr = 'companiesGridAllowMSPInProductTrialsVisibilityForMdr',
  RevokeMSPInProductTrialsVisibilityForEdr = 'companiesGridRevokeMSPInProductTrialsVisibilityForEdr',
  AllowMSPInProductTrialsVisibilityForEdr = 'companiesGridAllowMSPInProductTrialsVisibilityForEdr',
}
